export default defineNuxtRouteMiddleware((to) => {
  //check the length of schools if greater than 0 then update isUserSchools
  const isUserSchools =
    Object.keys(useLearnerSchoolsStore()?.schools ?? {}).length > 0;
  // if user is on add material page and has no schools, redirect to main page
  if (to.path === '/learner/startlearning/addMaterial' && !isUserSchools) {
    return navigateTo({ path: '/learner/startlearning/main' });
    // if user is on main page and has schools, redirect to add material page
  } else if (to.path === '/learner/startlearning/main' && isUserSchools) {
    return navigateTo({ path: '/learner/startlearning/addMaterial' });
  }
});
